import { Store as StoreModel, WorkDay } from '@core/models';

export type StoreWithAddress = StoreModel & {
	ubicacion: NonNullable<StoreModel['ubicacion']>;
};

export function hasStoreAddress(store: StoreModel | null | undefined): store is StoreWithAddress {
	return Boolean(store?.ubicacion?.direccion);
}

export function isBusinessDayClosed(workDay: WorkDay | null | undefined): boolean {
	return !workDay || !workDay.estaAbierto;
}

export function getStoreList(stores: StoreModel[] | null | undefined): StoreModel[] {
	return Array.isArray(stores) ? ([] as StoreModel[]).concat(...stores) : [];
}

export function isMultiStore(stores: readonly StoreModel[]): boolean {
	return stores.length > 1;
}
